export default __webpack_public_path__ + "static/media/Arrow.1ab5d35e.svg";